import { Controller } from "stimulus";

export default class extends Controller {
  static targets = ["seats", "newBalance", "button", "seatAction", "panel", "title"];
  static values = { balance: Number, seatAction: String };

  connect() {
    if (this.hasSeatsTarget) this.updateBalance();
  }

  changeSeatAction(event) {
    this.seatActionValue = event.detail.value;
    this.seatActionTarget.value = this.seatActionValue;
    this.updateBalance();
  }

  updateBalance() {
    const seats = parseInt(this.seatsTarget.value, 10) || 0;
    const change = this.seatActionValue === 'remove' ? -seats : seats;

    this.newBalanceTarget.textContent = (this.balanceValue + change).toLocaleString('en');

    this.buttonTargets.forEach(button => {
      button.classList.toggle('hidden', button.value !== this.seatActionValue);
    });
  }

  showPanel(event) {
    const view = event.detail.value;

    this.panelTargets.forEach(panel => {
      const shown = panel.dataset.view === view;

      panel.classList.toggle('hidden', !shown);
      panel.classList.toggle('flex', shown);
    });

    this.titleTarget.textContent = this.titleTarget.dataset[view];
  }
}
